import { useEffect, useState } from "react";
import OldGuide from "./old-guide/old_guide";
import NewGuide from "./new-guide/new_guide";
import style from "./guide.module.css";

// if want to use new styled component just send newStyleType props
export default function Guide({
  state = 0,
  stateTitles = [
    "เลือกความคุ้มครอง",
    "กรอกข้อมูลผุ้เอาประกัน",
    "ยืนยันข้อมูล",
    "ชำระเงิน",
  ],
}) {
  // const [designType, setDesignType] = useState(newStyleType)

  // useEffect(() => {
  //   //set design type for guide
  //   if(newStyleType !== "old" || !stateTitles) setDesignType(style)
  // }, [])

  return (
    <div className={style.guide_container}>
        <NewGuide
          state={state}
        />
    </div>
  )
}
